import { site, testimonials } from "@/mocks/hotlist";

const PRINCIPLES = [
  {
    icon: "ri-shield-check-line",
    title: "只整理公开讨论",
    text: "所有内容都来自各平台公开可见的讨论，仅做事实梳理与观点归类，不添加未经证实的推断。",
  },
  {
    icon: "ri-user-forbid-line",
    title: "统一使用代称",
    text: "涉及具体人物一律用某顶流、某综艺等代称，避免对未确认信息下结论，也减少无谓打扰。",
  },
  {
    icon: "ri-refresh-line",
    title: "标注更新时间",
    text: "榜单与复盘都明确标注更新时点，话题出现新进展时会补充说明，让读者知道信息的新旧程度。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-400 font-medium">
                <span className="w-6 h-px bg-accent-500" />
                关于本站
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-snug">
                我们只是把散落的热榜，重新排了一次序
              </h2>
              <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                {site.brand}是一个轻量的吃瓜热榜聚合首页。它不做原创爆料，也不生产情绪，而是把各平台此刻正在被讨论的话题收集起来，按热度、讨论量和传播增长重新排列，让读者用一分钟决定要不要往下看。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                我们相信阅读热榜这件事本身可以更高效：先看榜单建立印象，再按需进入话题复盘了解来龙去脉，而不是被无休止的信息流拖着走。
              </p>

              <div className="mt-8 grid grid-cols-2 gap-4">
                <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
                  <p className="font-heading text-2xl font-bold text-primary-400 tabular-nums">8</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">常驻话题分类</p>
                </div>
                <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
                  <p className="font-heading text-2xl font-bold text-secondary-400 tabular-nums">3</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">每日榜单更新</p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {PRINCIPLES.map((item) => (
                  <div
                    key={item.title}
                    className="rounded-lg border border-background-200/70 bg-background-100 p-5 flex flex-col"
                  >
                    <span className="w-11 h-11 rounded-lg bg-primary-500/10 border border-primary-500/25 flex items-center justify-center">
                      <i className={`${item.icon} text-xl text-primary-400`} />
                    </span>
                    <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>

              <h3 className="mt-10 font-heading text-lg md:text-xl font-bold text-foreground-950">
                读者怎么说
              </h3>
              <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {testimonials.map((t) => (
                  <figure
                    key={t.name}
                    className="rounded-lg border border-background-200/70 bg-background-100 p-5"
                  >
                    <div className="flex items-center gap-1 text-primary-400 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-sm" />
                      ))}
                    </div>
                    <blockquote className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                      {t.text}
                    </blockquote>
                    <figcaption className="mt-4 flex items-center gap-2.5">
                      <span className="w-8 h-8 rounded-full bg-secondary-500/15 text-secondary-400 flex items-center justify-center text-sm font-medium">
                        {t.name.slice(0, 1)}
                      </span>
                      <span>
                        <span className="block text-xs font-medium text-foreground-900">{t.name}</span>
                        <span className="block text-xs text-foreground-500">{t.role}</span>
                      </span>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}